import Discovery from './discovery'

export default Discovery
